import React from "react";

export const IconLinkedin = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M10.5217 21.999C16.3327 21.999 21.0435 17.0742 21.0435 10.999C21.0435 4.92389 16.3327 -0.000976562 10.5217 -0.000976562C4.71074 -0.000976562 0 4.92389 0 10.999C0 17.0742 4.71074 21.999 10.5217 21.999Z"
      fill="#FAFBFB"
    />
    <path
      d="M16.8082 11.8847V16.4197H14.2932V12.1886C14.2932 11.1262 13.9301 10.4007 13.0195 10.4007C12.3245 10.4007 11.9117 10.8891 11.7294 11.3621C11.6632 11.5311 11.6461 11.7658 11.6461 12.0029V16.4195H9.13096C9.13096 16.4195 9.16472 9.2534 9.13096 8.51161H11.6463V9.63224C11.6413 9.64106 11.6341 9.64969 11.6296 9.65812H11.6463V9.63224C11.9806 9.09457 12.5766 8.32592 13.913 8.32592C15.5676 8.32592 16.8082 9.45615 16.8082 11.8847ZM6.49986 4.69971C5.63953 4.69971 5.07666 5.29012 5.07666 6.06583C5.07666 6.82508 5.62321 7.43255 6.46685 7.43255H6.48317C7.36039 7.43255 7.90581 6.82508 7.90581 6.06583C7.88912 5.29012 7.36039 4.69971 6.49986 4.69971ZM5.22615 16.4197H7.74039V8.51161H5.22615V16.4197Z"
      fill="#007AB9"
    />
  </svg>
);
